import {
  FETCH_SETTINGS,
  FETCH_SETTINGS_SUCCESS,
  FETCH_SETTINGS_FAILED,
  EDIT_SETTINGS,
  CLEAR_SETTINGS_ERROR
} from "../store/types";

import {
  FirebaseConfig,
  language,
  AppDetails,
  mainUrl,
  cloud_function_server_url
} from '../../config';

const END_POINT = `${cloud_function_server_url}/settings`;

export const fetchSettings= () => (dispatch) => (firebase) => {
  // const {
  //   settingsRef
  // } = Firebases;

  dispatch({
    type: FETCH_SETTINGS,
    payload: null,
  });

  fetch(`${END_POINT}/fetch-settings`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(async (res) => {
      const response = await res.json();
      const data = response.data;
      dispatch({
        type: FETCH_SETTINGS_SUCCESS,
        payload: data,
      });
    }).catch(error => {
      console.log("fetchSettings error", error)
      dispatch({
        type: FETCH_SETTINGS_FAILED,
        payload: language.settings_error,
      });
    });

  // settingsRef.on("value", (snapshot) => {
  //   if (snapshot.val()) {
  //     dispatch({
  //       type: FETCH_SETTINGS_SUCCESS,
  //       payload: snapshot.val(),
  //     });
  //   } else {
  //     dispatch({
  //       type: FETCH_SETTINGS_FAILED,
  //       payload: language.settings_error,
  //     });
  //   }
  // });
};

export const editSettings = (settings) => (dispatch) => (firebase) => {
  const id = settings._id;
  delete settings._id
  // const {
  //   settingsRef
  // } = firebase;

  fetch(`${END_POINT}/edit-settings/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({data: settings})
  })
    .then(async (res) => {
      const response = await res.json();
      console.log("resp check", response)
      dispatch({
        type: EDIT_SETTINGS,
        payload: settings
      });
    }).catch(error => {
      console.log("fetchSettings error", error)
    });

  // if(settings.license){
  //   try {
  //     fetch(`https://us-central1-seradd.${mainUrl}/baseset`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({
  //         license: settings.license?settings.license: ' ',
  //         contact_email: settings.license?settings.contact_email: ' ',
  //         app_name: AppDetails.app_name,
  //         app_identifier: AppDetails.app_identifier,
  //         projectId: FirebaseConfig.projectId,
  //         createTime: new Date().toISOString(),
  //         reqType: 'settings'
  //       })
  //     }).then(response => response.json())
  //       .then((res) => {
  //         if (res.success) {
  //           dispatch({
  //             type: EDIT_SETTINGS,
  //             payload: settings
  //           });
  //           settingsRef.set(settings);
  //           // alert(language.updated);
  //         }else{
  //           alert(language.wrong_code);
  //         }
  //       }).catch(error=>{
  //         console.log(error);
  //       })
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }else{
  //   dispatch({
  //     type: EDIT_SETTINGS,
  //     payload: settings
  //   });
  //   settingsRef.set(settings);
  //   // alert(language.updated);
  // }
};

export const clearSettingsViewError = () => (dispatch) => (firebase) => {
  dispatch({
    type: CLEAR_SETTINGS_ERROR,
    payload: null
  });
};